import { useForm, FormProvider } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import _ from 'lodash';
import { ReplyPayload, Reply } from '../../schema';
import {
  notificationAtom,
  NotificationType,
  pageLoadingAtom,
} from '../../atoms/system';
import { popupReplyAtom } from '../../atoms/reply';
import { useSetAtom, useAtom } from 'jotai';
import { Loading } from '../../widgets';
import api from '../../api';
import { IResponse } from '../../types';
import FormReply from './Form.Reply';
import { Updater, useImmer } from 'use-immer';
import cuid from 'cuid';
import { useEffect } from 'react';
import produce from 'immer';
import { IReply } from '../../inter/detail';

const Edit = ({
  actionReload,
}: {
  actionReload: Updater<{
    load: string;
    trigger: boolean;
  }>;
}): JSX.Element => {
  const notification = useSetAtom(notificationAtom);
  const pageLoading = useSetAtom(pageLoadingAtom);
  const [showPopupRely, setShowPopupRely] = useAtom(popupReplyAtom);
  const form = useForm<ReplyPayload>({
    resolver: zodResolver(Reply),
  });
  const onSubmit = async (data: ReplyPayload) => {
    try {
      pageLoading(true);
      await api.post(`api/replies/detail/${showPopupRely.reply_id}`, {
        json: data,
      });
      notification({
        show: true,
        type: NotificationType.success,
        title: 'Cập nhật thành công',
      });
      actionReload(draft => {
        draft.load = cuid();
      });
    } catch (e) {
      console.log(e);
      notification({
        show: true,
        type: null,
        title: null,
      });
    } finally {
      pageLoading(false);
    }
  };
  const [loading, setLoading] = useImmer<boolean>(false);
  useEffect(() => {
    if (
      _.isString(showPopupRely.reply_id) &&
      showPopupRely.reply_id.length > 0 &&
      showPopupRely.show
    ) {
      (async () => {
        try {
          setLoading(true);
          const result = await api
            .get(`api/replies/detail/${showPopupRely.reply_id}`)
            .json<IResponse<IReply | null>>();
          if (_.isNull(result.data)) {
            throw Error();
          }
          form.reset({
            name: result.data.customer.name,
            email: result.data.customer.email,
            phone: result.data.customer.phone,
            desc: result.data.desc,
            target_id: result.data.pageTargetId,
            status: result.data.status,
          });
          setLoading(false);
        } catch (e) {
          console.log(e);
          setShowPopupRely(
            produce(draft => {
              draft.reply_id = null;
            }),
          );
          notification({
            show: true,
            type: null,
            title: null,
          });
        }
      })();
    }
  }, [showPopupRely.reply_id]);
  return (
    <FormProvider {...form}>
      <form className="w-full" onSubmit={form.handleSubmit(onSubmit)}>
        {loading ? (
          <div className="flex w-full h-full items-center justify-center">
            <Loading color="indigo-600" size={6} />
          </div>
        ) : (
          <div className="w-full">
            <div className="flex justify-between items-end">
              <h3 className="text-md font-medium text-gray-900">
                Chỉnh sửa trả lời
              </h3>
            </div>
            <FormReply />
            <div className="flex flex-col justify-center w-full mt-6 space-y-6">
              <button
                type="submit"
                className="flex w-full justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Cập nhật trả lời
              </button>
              <button
                type="button"
                className="text-sm font-medium text-indigo-600"
                onClick={() => {
                  setShowPopupRely(
                    produce(draft => {
                      draft.reply_id = null;
                    }),
                  );
                }}
              >
                Tạo trả lời mới
              </button>
            </div>
          </div>
        )}
      </form>
    </FormProvider>
  );
};

export default Edit;
